import styled from 'styled-components';

export const TyreLabelStyle = styled.section`
	display: flex;
	flex-direction: column;
	gap: 16px;

	& > a {
		align-self: flex-start;
	}
`;

export const ListStyle = styled.ul`
	display: flex;
	flex-wrap: wrap;
	gap: 32px;
`;

export const ListItemStyle = styled.li`
	display: flex;
	flex-direction: column;
	gap: 16px;

	& > a {
		align-self: flex-start;
	}
`;
